import { MonitoringOverview, useSriracha } from '@ltvco/refresh-lib';

export function Monitoring() {
  const { data } = useSriracha();
  const notifications = data || [];

  return <MonitoringOverview notifications={notifications} />;
}
